import React, { useEffect, useState } from "react";
import { useLanguage, T, pickBilingual } from "@/lib/i18n";


const DEFAULT_GALLERY_ITEM = {
  id: "default-gallery-image",
  image_url:
    "https://i0.wp.com/www.socialnews.xyz/wp-content/uploads/2024/03/03/20240303059-scaled.jpg?fit=2560%2C1580&quality=80&zoom=1&ssl=1?v=1709472617",
  caption_en: "Leader in action at the gala",
  caption_bn: "গালার অনুষ্ঠানে নেতার কর্মসংস্থল",
};

export default function Gallery() {
  const { lang } = useLanguage();
  const galleryItems = [DEFAULT_GALLERY_ITEM];

  return (
    <section id="gallery" data-testid="gallery-section" className="bg-sjm-mist border-t border-sjm-line">
      <div className="max-w-7xl mx-auto px-6 sm:px-8 lg:px-12 py-20 sm:py-28 lg:py-32">
        <div className="mb-12">
          <div className="text-xs font-bold uppercase tracking-[0.2em] text-sjm-red">{T.gallery.eyebrow[lang]}</div>
          <h2 className={`mt-3 font-display font-extrabold tracking-tighter text-3xl sm:text-4xl lg:text-5xl text-sjm-ink ${lang === "bn" ? "font-bn" : ""}`}>
            {T.gallery.title[lang]}
          </h2>
        </div>

        <div className="grid grid-cols-2 lg:grid-cols-4 gap-3 sm:gap-4">
          {galleryItems.map((g, i) => (
            <figure
              key={g.id}
              data-testid={`gallery-item-${i}`}
              className={`group relative overflow-hidden border border-sjm-line bg-white ${i % 5 === 0 ? "lg:col-span-2 lg:row-span-2 aspect-square" : "aspect-square"}`}
            >
              <img
                src={g.image_url}
                alt={pickBilingual(g, "caption", lang)}
                className="w-full h-full object-cover transition-transform duration-700 group-hover:scale-105"
                loading="lazy"
              />
              <figcaption className="absolute bottom-0 left-0 right-0 p-4 bg-gradient-to-t from-sjm-ink/80 via-sjm-ink/30 to-transparent text-white text-xs sm:text-sm opacity-0 group-hover:opacity-100 transition-opacity">
                <span className={lang === "bn" ? "font-bn" : ""}>{pickBilingual(g, "caption", lang)}</span>
              </figcaption>
            </figure>
          ))}
        </div>
      </div>
    </section>
  );
}
